import { useEffect, useState } from 'react';

import { screens } from '@styles';

const defaultScreens: Record<keyof typeof screens, boolean> = {
  sm: false,
  md: false,
  lg: false,
  xl: false,
  xxl: false,
};

const getScreens = () => {
  const width = window.innerWidth;
  const newScreen = { ...defaultScreens };
  Object.keys(defaultScreens).forEach((key: any) => {
    newScreen[key as keyof typeof screens] =
      width >= screens[key as keyof typeof screens];
  });

  return newScreen;
};

export const useResponsivity = () => {
  const [screen, setScreen] = useState(() => {
    if (typeof window === 'undefined') return defaultScreens;

    return getScreens();
  });

  useEffect(() => {
    const handleResize = () => {
      setScreen(getScreens());
    };

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return { screen };
};
